import Vue from 'vue';
import WalletBar from '../../parts/WalletBar.vue';
import ToolBar from "../../parts/ToolBar.vue";
import { MUTATION_TYPES } from "../../../lib/mutationTypes";
import 'vue-i18n';
export default Vue.extend({
    components: {
        ToolBar,
        WalletBar
    },
    name: "SendMode",
    data() {
        return {
            items: [
                {
                    image: 'image_send_card1.png',
                    title: this.$t('send.standard_title'),
                    hint: this.$t('send.standard_hint'),
                    message: this.$t('send.standard_message'),
                    to: '/send/confirmation',
                },
                {
                    image: 'image_send_card2.png',
                    title: this.$t('send.message_title'),
                    hint: this.$t('send.message_hint'),
                    message: this.$t('send.message_message'),
                    to: '/send/message',
                },
            ],
        };
    },
    methods: {
        goNext(to) {
            this.$store.commit(MUTATION_TYPES.CLEAR_SEND_MESSAGE);
            this.$store.commit(MUTATION_TYPES.SET_BACK_PATH_FROM_SEND_CONFIRMATION, this.$router.currentRoute.path);
            this.$router.push(to);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/send/SendMode.vue
// module id = 651
// module chunks = 1